import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Box, Container, Grid, Link, Typography } from '@mui/material';
import LocationPinIcon from '@mui/icons-material/LocationPin';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

const footerSections = [
  {
    title: 'Who We Are',
    links: [
      { label: 'Our Journey', href: '/', isExternal: false },
      { label: 'Our Company', href: 'https://novaarktechlabs.com', isExternal: true },
    ],
  },
  {
    title: 'Intercom',
    links: [
      { label: 'Our Communication Policy', href: '/intercom/privacypolicy' },
      { label: 'Terms of Usage', href: '/intercom/terms' },
    ],
  },
];

export default function NovaArkFooter() {
  const location = useLocation();
  const whiteBgRoutes = [
    '/compliance/terms',
    '/compliance/privacypolicy'
  ];
  const isWhiteBackground = whiteBgRoutes.includes(location.pathname);
  return (
    <Box component="footer" sx={{
      bgcolor: isWhiteBackground ? 'white' : '#2253A2',
      color: isWhiteBackground ? 'black' : 'white', pt: 3, pb: 2, mt: -2
    }}>
      <Container>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6} md={3} key={1}>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: isWhiteBackground ? 'black' : 'inherit' }}>
                {footerSections[0].title}
              </Typography>
              {footerSections[0].links.map((link, idx) => (
                <Typography key={idx} variant="body2" sx={{ color: isWhiteBackground ? 'gray.800' : 'gray.300', mb: 0.5 }}>
                  {
                    link.isExternal
                    ? (
                      <Link href={link.href} color="inherit" underline="hover" target="_blank" rel="noopener noreferrer">
                        {link.label}
                      </Link>
                      )
                    : (<Link component={RouterLink} to={link.href} color="inherit" underline="hover">
                        {link.label}
                      </Link>
                      )  
                  }
                </Typography>
              ))}
            </Grid>
          {footerSections.slice(1,2).map((section, index) => (
            <Grid item xs={12} sm={6} md={3} key={index+1}>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: isWhiteBackground ? 'black' : 'inherit' }}>
                {section.title}
              </Typography>
              {section.links.map((link, idx) => (
                <Typography key={idx} variant="body2" sx={{ color: isWhiteBackground ? 'gray.800' : 'gray.300', mb: 0.5 }}>
                  <Link component={RouterLink} to={link.href} color="inherit" underline="hover">
                    {link.label}
                  </Link>
                </Typography>
              ))}
            </Grid>
          ))}
        </Grid>

        {/* Divider and legal */}
        <Box sx={{ borderTop: '1px solid #444', mt: 3, pt: 1 }}>
          <Grid container spacing={3} direction="column">
            <Grid item>
              <Box>
                <Typography textAlign={"center"} variant="body2">
                  <LocationPinIcon sx={{color: 'red', mx: 1}}/>
                  NOVAARK TECH LABS, Building No: 9, Floor 13, Raheja Mindspace IT Park, Mindspace, Madhapur Road, Hitech city, Hyderabad 500081
                </Typography>
              </Box>
            </Grid>
            <Grid item display={"flex"} flexDirection={{ md: "row", sm: "column", xs: "column" }} justifyContent={"space-between"}>
              <Box sx={{ gap: 2, display: 'flex', justifyContent: 'center', gap: 2 }}>
                  <Link 
                    href="https://www.instagram.com/novaarktechlabs" 
                    color="inherit" 
                    underline="hover" 
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    <InstagramIcon/>
                  </Link>
                  <Link 
                    href="https://www.linkedin.com/company/novaark-tech-labs" 
                    color="inherit" 
                    underline="hover" 
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    <LinkedInIcon />
                  </Link>
              </Box>
              <Box>
                <Box sx={{ gap: 2, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                  <Link component={RouterLink} to="/compliance/terms" color="inherit" underline="hover">
                    Terms of Usage
                  </Link>
                  <Link component={RouterLink} to="/compliance/privacypolicy" color="inherit" underline="hover">
                    Cookies & PrivacyPolicy
                  </Link>
                </Box>
              </Box>
            </Grid>
          </Grid>
          <Typography textAlign={"center"} variant="body2" sx={{color:'grey'}}>
            ©2025 NOVAARK Technologies Pvt. Ltd. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}